


























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { FaxLine, ForwardingNumber } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import { storeService, userService } from '@/shared';
import { Utils } from '@/helper/utils';
import { mapGetters } from 'vuex';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    ...mapGetters({ dashboardDetails: 'getDashboardDetails' }),
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class SaveRfIdPage extends Base {
  public form: any = {};
  public storeRfIdFields: Array<VFields<any>> = [];
  public storeRfIdModel = {
    id: '',
    ipAddress: '',
    antenna: 'Antenna1',
    protocol: 'Alien',
    serverName: '',
    locationName: '',
    locationId: '',
    isEnabled: true,
  };
  public dateTime: any;
  public storeId: number = 0;
  public requestProgress: boolean = false;

  public AntennaList?: any[] = [
    {
      text: 'Nothing',
      value: 'Nothing',
    },
    {
      text: 'Antenna1',
      value: 'Antenna1',
    }, 
    {
      text: 'Antenna2',
      value: 'Antenna2',
    },
    {
      text: 'Antenna3',
      value: 'Antenna3',
    },
    {
      text: 'Antenna4',
      value: 'Antenna4',
    },
  ];

  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.storeId.toString(), tab: 'RfId' },
        })
        .catch((ex) => {
          console.log(ex);
        });
    }
    if (methodName === 'saveStoreRfId') {
      if (!this.form.$valid) {
        this.showAlert(false, 'Form is Invalid!');
        this.resetMethodName(methodName);
        return;
      }
      this.saveStoreRfId();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreEdit',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }

  public mounted() {
    this.storeId = Number(this.$route.params.storeId);
    
    if (this.$route.params.rfId) {
      this.getRfIdDetails();
    }
    this.setStoreIpFields();
    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
  }

  public setStoreIpFields(): void {
    this.storeRfIdFields = [      
      {
        key: 'serverName',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'Reader Name',
          loading: false,
          required: true,
          elementClass:
            'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules: [(v) => this.required('RFID Name', v)],
        },
      },
      {
        key: 'ipAddress',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          disabled: false,
          label: 'Ip Address',
          required: true,
          loading: false,
          elementClass:
            'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules: [(v) => this.required('Ip Address', v)],
        },
      },
      {
        key: 'protocol',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'Protocol',
          loading: false,
          required: true,
          elementClass:
            'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules: [(v) => this.required('Protocol', v)],
        },
      },
      {
        key: 'antenna',
        required: false,
        type: 'v-alynk-select',
        templateOptions: {
          required: false,
          disabled: false,
          label: 'Antenna',
          text: 'text',
          value: 'value',
          items: this.AntennaList,
          loading: false,
          elementClass:
            'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-3 float-right',
        },
      },
      {
        key: 'locationName',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'Location Name',
          loading: false,
          required: true,
          elementClass:
            'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules: [(v) => this.required('LocationName', v)],
        },
      },
      {
        key: 'locationId',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'DMS Location Id',
          loading: false,
          required: true,
          elementClass:
            'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules: [(v) => this.required('LocationId', v)],
        },
      },
      {
        key: 'isEnabled',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: 'Enable RfId',
          validations: '',
          loading: false,
          elementClass:
            'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
        },
      },
    ];
  }

  public async getRfIdDetails(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.storeRfIdFields);
      const response = await storeService.getRfId(this.storeId);
      const rfIdDetail = response.storeJson.rfIds.find(
        (m) => m.id == this.$route.params.rfId
      );
      
      this.storeRfIdModel = rfIdDetail;
    } finally {
      this.formlyHideSkeleton(this.storeRfIdFields);
    }
  }

  public validateStoreRfId(): Vue & { validate: () => boolean } {
    return this.$refs.storeRfIdForm as Vue & { validate: () => boolean };
  }

  public async saveStoreRfId(): Promise<void> {
    if (this.validateStoreRfId().validate()) {
      try {
        this.requestProgress = true;
        this.$emit('update:progress', this.requestProgress);
        if (this.storeRfIdModel.id == '') {
          await storeService.saveStoreRfId(this.storeId, this.storeRfIdModel);
          this.showAlert(true, 'Store RfId Added successfully');
          this.$router
            .push({
              name: 'admin.stores.edit',
              params:{
                tab: 'RfId'
              }
            })
            .catch((ex) => {
              console.log(ex);
            });
        } else {
          await storeService.updateStoreRfId(this.storeId, this.storeRfIdModel);
          this.showAlert(true, 'Store RfId Updated successfully');
          this.$router
            .push({
              name: 'admin.stores.edit',
              params: {
                storeId: this.storeId.toString(),
                tab: 'RfId'
              },
            })
            .catch((ex) => {
              console.log(ex);
            });
        }
      } finally {
        this.requestProgress = false;
        this.$emit('update:progress', this.requestProgress);
      }
    }
  }
}
